/**
 * Global logout handler that clears the user ID from Embrace SDK (best-effort)
 * and executes any additional handler logic.
 * @param additionalHandler Optional function to execute after logout completes
 */
export const handleLogout = (additionalHandler?: () => void) => {
  import('@embrace-io/web-sdk')
    .then(({ user }) => {
      user.clearUserId();
    })
    .catch(() => {})
    .finally(() => {
      if (additionalHandler) {
        additionalHandler();
      }
    });
};
